import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  var _widgetBlock$closest;

  var widgetBlock = node.childNodes[0];

  if (!widgetBlock || widgetBlock && !widgetBlock.getAttribute('data-uids')) {
    return {};
  } // dynamicBlock shimmer uses minHeight from closest row


  var row = (_widgetBlock$closest = widgetBlock.closest('[data-content-type="row"]')) === null || _widgetBlock$closest === void 0 ? void 0 : _widgetBlock$closest.firstChild;
  return _objectSpread({
    minHeight: row && row.style.minHeight ? row.style.minHeight : null,
    displayInline: widgetBlock.getAttribute('class').includes('block-banners-inline'),
    displayMode: widgetBlock.getAttribute('data-display-mode'),
    uids: widgetBlock.getAttribute('data-uids')
  }, getAdvanced(node));
});